import React from 'react';
import PropTypes from 'prop-types';

import Alert from 'components/Alert/Alert';

import getDisplayName from 'utils/getDisplayName';

function WithProcessError(WrappedComponent) {
    const withProcessErrorHoc = (props) => {
        const [showAlert, setShowAlert] = React.useState(null);

        function composeErrorText(errorData) {
            console.error(errorData);

            const { loc, msg } = errorData;
            let errorLocation = loc || 'unknown';

            if (Array.isArray(errorLocation)) {
                errorLocation = errorLocation.join('/');
            }

            let message = msg;

            if (typeof msg === 'object') {
                if (msg.message) {
                    message = msg.message;
                } else {
                    message = JSON.stringify(msg);
                }
            }

            return `loc: ${errorLocation}\n` + (msg ? `msg: ${message}` : errorData);
        }

        function handleAlertClose() {
            setShowAlert(null);
        }

        /**
         * Display error alert with title and details.
         * @param {string} title Alert title.
         * @param {object} errorData Error details object.
         */
        function processError(title, errorData) {
            if (!title) {
                errorData = title;
                title = 'Неизвестная ошибка';
            }

            setShowAlert(
                <Alert
                    title={title}
                    onClose={handleAlertClose}
                    content={composeErrorText(errorData)}
                />
            );
        }

        return (
            <>
                {showAlert}
                <WrappedComponent processError={processError} {...props} />
            </>
        );
    };

    withProcessErrorHoc.displayName = `WithProcessError(${getDisplayName(WrappedComponent)})`;

    return withProcessErrorHoc;
};

WithProcessError.propTypes = {
    WrappedComponent: PropTypes.element,
};

export default WithProcessError;
